export const FETCH_DATA_SUBMIT_HOST = 'FETCH_DATA_SUBMIT_HOST';
export const FETCH_DATA_SUBMIT_SUCCESS_HOST = 'FETCH_DATA_SUBMIT_SUCCESS_HOST';
export const FETCH_DATA_SUBMIT_FAILS_HOST = 'FETCH_DATA_SUBMIT_FAILS_HOST';
export const CLEAR_DATA_SUBMIT_HOST = 'CLEAR_DATA_SUBMIT_HOST';
